function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Command, Plugin, icons } from '@ckeditor/ckeditor5-core/dist/index.js';
import { logWarning, CKEditorError, first } from '@ckeditor/ckeditor5-utils/dist/index.js';
import { ButtonView, createDropdown, addToolbarToDropdown, MenuBarMenuView, MenuBarMenuListView, MenuBarMenuListItemView, MenuBarMenuListItemButtonView } from '@ckeditor/ckeditor5-ui/dist/index.js';
/**
 * @module alignment/utils
 */

/**
* The list of supported alignment options:
*
* * `'left'`,
* * `'right'`,
* * `'center'`,
* * `'justify'`
*/

var supportedOptions = ['left', 'right', 'center', 'justify'];
/**
 * Checks whether the passed option is supported by {@link module:alignment/alignmentediting~AlignmentEditing}.
 *
 * @param option The option value to check.
 */

function isSupported(option) {
  return supportedOptions.includes(option);
}
/**
 * Checks whether alignment is the default one considering the direction
 * of the editor content.
 *
 * @param alignment The name of the alignment to check.
 * @param locale The {@link module:core/editor/editor~Editor#locale} instance.
 */


function isDefault(alignment, locale) {
  // Right now only LTR is supported so the 'left' value is always the default one.
  if (locale.contentLanguageDirection == 'rtl') {
    return alignment === 'right';
  } else {
    return alignment === 'left';
  }
}
/**
 * Brings the configuration to the common form, an array of objects.
 *
 * @param configuredOptions Alignment plugin configuration.
 * @returns Normalized object holding the configuration.
 */


function normalizeAlignmentOptions(configuredOptions) {
  var normalizedOptions = configuredOptions.map(function (option) {
    var result;

    if (typeof option == 'string') {
      result = {
        name: option
      };
    } else {
      result = option;
    }

    return result;
  }) // Remove all unknown options.
  .filter(function (option) {
    var isNameValid = supportedOptions.includes(option.name);

    if (!isNameValid) {
      /**
      * The `name` in one of the `alignment.options` is not recognized.
      * The available options are: `'left'`, `'right'`, `'center'` and `'justify'`.
      *
      * @error alignment-config-name-not-recognized
      * @param option Options with unknown value of the `name` property.
      */
      logWarning('alignment-config-name-not-recognized', {
        option: option
      });
    }

    return isNameValid;
  });
  var classNameCount = normalizedOptions.filter(function (option) {
    return Boolean(option.className);
  }).length; // We either use classes for all styling options or for none.

  if (classNameCount && classNameCount < normalizedOptions.length) {
    /**
    * The `className` property has to be defined for all options once at least one option declares `className`.
    *
    * @error alignment-config-classnames-are-missing
    * @param configuredOptions Contents of `alignment.options`.
    */
    throw new CKEditorError('alignment-config-classnames-are-missing', {
      configuredOptions: configuredOptions
    });
  } // Validate resulting config.


  normalizedOptions.forEach(function (option, index, allOptions) {
    var succeedingOptions = allOptions.slice(index + 1);
    var nameAlreadyExists = succeedingOptions.some(function (item) {
      return item.name == option.name;
    });

    if (nameAlreadyExists) {
      /**
      * The same `name` in one of the `alignment.options` was already declared.
      * Each `name` representing one alignment option can be set exactly once.
      *
      * @error alignment-config-name-already-defined
      * @param option First option that declares given `name`.
      * @param configuredOptions Contents of `alignment.options`.
      */
      throw new CKEditorError('alignment-config-name-already-defined', {
        option: option,
        configuredOptions: configuredOptions
      });
    } // The `className` property is present. Check for duplicates then.


    if (option.className) {
      var classNameAlreadyExists = succeedingOptions.some(function (item) {
        return item.className == option.className;
      });

      if (classNameAlreadyExists) {
        /**
        * The same `className` in one of the `alignment.options` was already declared.
        *
        * @error alignment-config-classname-already-defined
        * @param option First option that declares given `className`.
        * @param configuredOptions
        * Contents of `alignment.options`.
        */
        throw new CKEditorError('alignment-config-classname-already-defined', {
          option: option,
          configuredOptions: configuredOptions
        });
      }
    }
  });
  return normalizedOptions;
}

var ALIGNMENT = 'alignment';
/**
 * The alignment command plugin.
 */

var AlignmentCommand = /*#__PURE__*/function (_Command) {
  _inherits(AlignmentCommand, _Command);

  var _super = _createSuper(AlignmentCommand);

  function AlignmentCommand() {
    _classCallCheck(this, AlignmentCommand);

    return _super.apply(this, arguments);
  }

  _createClass(AlignmentCommand, [{
    key: "refresh",
    value:
    /**
    * @inheritDoc
    */
    function refresh() {
      var editor = this.editor;
      var locale = editor.locale;
      var firstBlock = first(this.editor.model.document.selection.getSelectedBlocks()); // As first check whether to enable or disable the command as the value will always be false if the command cannot be enabled.

      this.isEnabled = Boolean(firstBlock) && this._canBeAligned(firstBlock);

      if (this.isEnabled && firstBlock.hasAttribute('alignment')) {
        this.value = firstBlock.getAttribute('alignment');
      } else {
        this.value = locale.contentLanguageDirection === 'rtl' ? 'right' : 'left';
      }
    }
    /**
    * Executes the command. Applies the alignment `value` to the selected blocks.
    * If no `value` is passed, the `value` is the default one or it is equal to the currently selected block's alignment attribute,
    * the command will remove the attribute from the selected blocks.
    *
    * @param options Options for the executed command.
    * @param options.value The value to apply.
    * @fires execute
    */

  }, {
    key: "execute",
    value: function execute() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var editor = this.editor;
      var locale = editor.locale;
      var model = editor.model;
      var doc = model.document;
      var value = options.value;
      model.change(function (writer) {
        // Get only those blocks from selected that can have alignment set
        var blocks = Array.from(doc.selection.getSelectedBlocks()).filter(function (block) {
          return _this._canBeAligned(block);
        });
        var currentAlignment = blocks[0].getAttribute('alignment'); // Remove alignment attribute if current alignment is:
        // - default (should not be stored in model as it will bloat model data)
        // - equal to currently set
        // - or no value is passed - denotes default alignment.

        var removeAlignment = isDefault(value, locale) || currentAlignment === value || !value;

        if (removeAlignment) {
          removeAlignmentFromSelection(blocks, writer);
        } else {
          setAlignmentOnSelection(blocks, writer, value);
        }
      });
    }
    /**
    * Checks whether a block can have alignment set.
    *
    * @param block The block to be checked.
    */

  }, {
    key: "_canBeAligned",
    value: function _canBeAligned(block) {
      return this.editor.model.schema.checkAttribute(block, ALIGNMENT);
    }
  }]);

  return AlignmentCommand;
}(Command);
/**
 * Removes the alignment attribute from blocks.
 */


function removeAlignmentFromSelection(blocks, writer) {
  var _iterator = _createForOfIteratorHelper(blocks),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var block = _step.value;
      writer.removeAttribute(ALIGNMENT, block);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
/**
 * Sets the alignment attribute on blocks.
 */


function setAlignmentOnSelection(blocks, writer, alignment) {
  var _iterator2 = _createForOfIteratorHelper(blocks),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var block = _step2.value;
      writer.setAttribute(ALIGNMENT, alignment, block);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}
/**
 * The alignment editing feature. It introduces the {@link module:alignment/alignmentcommand~AlignmentCommand command} and adds
 * the `alignment` attribute for block elements in the {@link module:engine/model/model~Model model}.
 */


var AlignmentEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(AlignmentEditing, _Plugin);

  var _super2 = _createSuper(AlignmentEditing);

  /**
  * @inheritDoc
  */
  function AlignmentEditing(editor) {
    var _this2;

    _classCallCheck(this, AlignmentEditing);

    _this2 = _super2.call(this, editor);
    editor.config.define('alignment', {
      options: supportedOptions.map(function (option) {
        return {
          name: option
        };
      })
    });
    return _this2;
  }
  /**
  * @inheritDoc
  */


  _createClass(AlignmentEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var locale = editor.locale;
      var schema = editor.model.schema;
      var options = normalizeAlignmentOptions(editor.config.get('alignment.options')); // Filter out unsupported options and those that are redundant, e.g. `left` in LTR / `right` in RTL mode.

      var optionsToConvert = options.filter(function (option) {
        return isSupported(option.name) && !isDefault(option.name, locale);
      }); // Once there is at least one `className` defined, we switch to alignment with classes.

      var shouldUseClasses = optionsToConvert.some(function (option) {
        return !!option.className;
      }); // Allow alignment attribute on all blocks.

      schema.extend('$block', {
        allowAttributes: 'alignment'
      });
      editor.model.schema.setAttributeProperties('alignment', {
        isFormatting: true
      });

      if (shouldUseClasses) {
        editor.conversion.attributeToAttribute(buildClassDefinition(optionsToConvert));
      } else {
        // Downcast inline styles.
        editor.conversion.for('downcast').attributeToAttribute(buildDowncastInlineDefinition(optionsToConvert));
      }

      var upcastInlineDefinitions = buildUpcastInlineDefinitions(optionsToConvert); // Always upcast from inline styles.

      var _iterator3 = _createForOfIteratorHelper(upcastInlineDefinitions),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var definition = _step3.value;
          editor.conversion.for('upcast').attributeToAttribute(definition);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var upcastCompatibilityDefinitions = buildUpcastCompatibilityDefinitions(optionsToConvert); // Always upcast from deprecated `align` attribute.

      var _iterator4 = _createForOfIteratorHelper(upcastCompatibilityDefinitions),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _definition = _step4.value;
          editor.conversion.for('upcast').attributeToAttribute(_definition);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      editor.commands.add('alignment', new AlignmentCommand(editor));
    }
  }], [{
    key: "pluginName",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return 'AlignmentEditing';
    }
  }]);

  return AlignmentEditing;
}(Plugin);
/**
 * Prepare downcast conversion definition for inline alignment styling.
 */


function buildDowncastInlineDefinition(options) {
  var view = {};

  var _iterator5 = _createForOfIteratorHelper(options),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _ref2 = _step5.value;
      var name = _ref2.name;
      view[name] = {
        key: 'style',
        value: {
          'text-align': name
        }
      };
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  var definition = {
    model: {
      key: 'alignment',
      values: options.map(function (option) {
        return option.name;
      })
    },
    view: view
  };
  return definition;
}
/**
 * Prepare upcast definitions for inline alignment styles.
 */


function buildUpcastInlineDefinitions(options) {
  var definitions = [];

  var _iterator6 = _createForOfIteratorHelper(options),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _ref4 = _step6.value;
      var name = _ref4.name;
      definitions.push({
        view: {
          key: 'style',
          value: {
            'text-align': name
          }
        },
        model: {
          key: 'alignment',
          value: name
        }
      });
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return definitions;
}
/**
 * Prepare upcast definitions for deprecated `align` attribute.
 */


function buildUpcastCompatibilityDefinitions(options) {
  var definitions = [];

  var _iterator7 = _createForOfIteratorHelper(options),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _ref6 = _step7.value;
      var name = _ref6.name;
      definitions.push({
        view: {
          key: 'align',
          value: name
        },
        model: {
          key: 'alignment',
          value: name
        }
      });
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return definitions;
}
/**
 * Prepare conversion definitions for upcast and downcast alignment with classes.
 */


function buildClassDefinition(options) {
  var view = {};

  var _iterator8 = _createForOfIteratorHelper(options),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var option = _step8.value;
      view[option.name] = {
        key: 'class',
        value: option.className
      };
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  var definition = {
    model: {
      key: 'alignment',
      values: options.map(function (option) {
        return option.name;
      })
    },
    view: view
  };
  return definition;
}

var iconsMap = /* #__PURE__ */function () {
  return new Map([['left', icons.alignLeft], ['right', icons.alignRight], ['center', icons.alignCenter], ['justify', icons.alignJustify]]);
}();
/**
 * The default alignment UI plugin.
 *
 * It introduces the `'alignment:left'`, `'alignment:right'`, `'alignment:center'` and `'alignment:justify'` buttons
 * and the `'alignment'` dropdown.
 */


var AlignmentUI = /*#__PURE__*/function (_Plugin2) {
  _inherits(AlignmentUI, _Plugin2);

  var _super3 = _createSuper(AlignmentUI);

  function AlignmentUI() {
    _classCallCheck(this, AlignmentUI);

    return _super3.apply(this, arguments);
  }

  _createClass(AlignmentUI, [{
    key: "localizedOptionTitles",
    get:
    /**
    * Returns the localized option titles provided by the plugin.
    *
    * The following localized titles corresponding with
    * {@link module:alignment/alignmentconfig~AlignmentConfig#options} are available:
    *
    * * `'left'`,
    * * `'right'`,
    * * `'center'`,
    * * `'justify'`.
    *
    * @readonly
    */
    function get() {
      var t = this.editor.t;
      return {
        'left': t('Align left'),
        'right': t('Align right'),
        'center': t('Align center'),
        'justify': t('Justify')
      };
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      var _this3 = this;

      var editor = this.editor;
      var options = normalizeAlignmentOptions(editor.config.get('alignment.options'));
      options.map(function (option) {
        return option.name;
      }).filter(isSupported).forEach(function (option) {
        return _this3._addButton(option);
      });

      this._addToolbarDropdown(options);

      this._addMenuBarMenu(options);
    }
    /**
    * Helper method for initializing the button and linking it with an appropriate command.
    *
    * @param option The name of the alignment option for which the button is added.
    */

  }, {
    key: "_addButton",
    value: function _addButton(option) {
      var _this4 = this;

      var editor = this.editor;
      editor.ui.componentFactory.add("alignment:".concat(option), function (locale) {
        return _this4._createButton(locale, option);
      });
    }
    /**
    * Helper method for creating the button view element.
    *
    * @param locale Editor locale.
    * @param option The name of the alignment option for which the button is added.
    * @param buttonAttrs Optional parameters passed to button view instance.
    */

  }, {
    key: "_createButton",
    value: function _createButton(locale, option) {
      var buttonAttrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var editor = this.editor;
      var command = editor.commands.get('alignment');
      var buttonView = new ButtonView(locale);
      buttonView.set(_objectSpread({
        label: this.localizedOptionTitles[option],
        icon: iconsMap.get(option),
        tooltip: true,
        isToggleable: true
      }, buttonAttrs)); // Bind button model to command.

      buttonView.bind('isEnabled').to(command);
      buttonView.bind('isOn').to(command, 'value', function (value) {
        return value === option;
      }); // Execute command.

      this.listenTo(buttonView, 'execute', function () {
        editor.execute('alignment', {
          value: option
        });
        editor.editing.view.focus();
      });
      return buttonView;
    }
    /**
    * Helper method for initializing the toolnar dropdown and linking it with an appropriate command.
    *
    * @param option The name of the alignment option for which the button is added.
    */

  }, {
    key: "_addToolbarDropdown",
    value: function _addToolbarDropdown(options) {
      var _this5 = this;

      var editor = this.editor;
      var factory = editor.ui.componentFactory;
      factory.add('alignment', function (locale) {
        var dropdownView = createDropdown(locale);
        var tooltipPosition = locale.uiLanguageDirection === 'rtl' ? 'w' : 'e';
        var t = locale.t; // Add existing alignment buttons to dropdown's toolbar.

        addToolbarToDropdown(dropdownView, function () {
          return options.map(function (option) {
            return _this5._createButton(locale, option.name, {
              tooltipPosition: tooltipPosition
            });
          });
        }, {
          enableActiveItemFocusOnDropdownOpen: true,
          isVertical: true,
          ariaLabel: t('Text alignment toolbar')
        }); // Configure dropdown properties an behavior.

        dropdownView.buttonView.set({
          label: t('Text alignment'),
          tooltip: true
        });
        dropdownView.extendTemplate({
          attributes: {
            class: 'ck-alignment-dropdown'
          }
        }); // The default icon depends on the direction of the content.

        var defaultIcon = locale.contentLanguageDirection === 'rtl' ? iconsMap.get('right') : iconsMap.get('left');
        var command = editor.commands.get('alignment'); // Change icon to reflect current selection's alignment.

        dropdownView.buttonView.bind('icon').to(command, 'value', function (value) {
          return iconsMap.get(value) || defaultIcon;
        }); // Enable button if any of the buttons is enabled.

        dropdownView.bind('isEnabled').to(command, 'isEnabled'); // Focus the editable after executing the command.
        // Overrides a default behaviour where the focus is moved to the dropdown button (#12125).

        _this5.listenTo(dropdownView, 'execute', function () {
          editor.editing.view.focus();
        });

        return dropdownView;
      });
    }
    /**
    * Creates a menu for all alignment options to use either in menu bar.
    *
    * @param options Normalized alignment options from config.
    */

  }, {
    key: "_addMenuBarMenu",
    value: function _addMenuBarMenu(options) {
      var _this6 = this;

      var editor = this.editor;
      editor.ui.componentFactory.add('menuBar:alignment', function (locale) {
        var command = editor.commands.get('alignment');
        var t = locale.t;
        var menuView = new MenuBarMenuView(locale);
        var listView = new MenuBarMenuListView(locale);
        menuView.bind('isEnabled').to(command);
        listView.set({
          ariaLabel: t('Text alignment'),
          role: 'menu'
        });
        menuView.buttonView.set({
          label: t('Text alignment')
        });

        var _iterator9 = _createForOfIteratorHelper(options),
            _step9;

        try {
          var _loop = function _loop() {
            var option = _step9.value;
            var listItemView = new MenuBarMenuListItemView(locale, menuView);
            var buttonView = new MenuBarMenuListItemButtonView(locale);
            buttonView.delegate('execute').to(menuView);
            buttonView.set({
              label: _this6.localizedOptionTitles[option.name],
              icon: iconsMap.get(option.name),
              role: 'menuitemcheckbox',
              isToggleable: true
            });
            buttonView.on('execute', function () {
              editor.execute('alignment', {
                value: option.name
              });
              editor.editing.view.focus();
            });
            buttonView.bind('isOn').to(command, 'value', function (value) {
              return value === option.name;
            });
            buttonView.bind('isEnabled').to(command, 'isEnabled');
            listItemView.children.add(buttonView);
            listView.items.add(listItemView);
          };

          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }

        menuView.panelView.children.add(listView);
        return menuView;
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return 'AlignmentUI';
    }
  }]);

  return AlignmentUI;
}(Plugin);
/**
 * The text alignment plugin.
 *
 * For a detailed overview, check the {@glink features/text-alignment Text alignment} feature guide
 * and the {@glink api/alignment package page}.
 *
 * This is a "glue" plugin which loads the {@link module:alignment/alignmentediting~AlignmentEditing} and
 * {@link module:alignment/alignmentui~AlignmentUI} plugins.
 */


var Alignment = /*#__PURE__*/function (_Plugin3) {
  _inherits(Alignment, _Plugin3);

  var _super4 = _createSuper(Alignment);

  function Alignment() {
    _classCallCheck(this, Alignment);

    return _super4.apply(this, arguments);
  }

  _createClass(Alignment, null, [{
    key: "requires",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return [AlignmentEditing, AlignmentUI];
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "pluginName",
    get: function get() {
      return 'Alignment';
    }
  }]);

  return Alignment;
}(Plugin);

export { Alignment, AlignmentEditing, AlignmentUI };